import {
  translationChunksConfig,
  translationsDe,
  translationsEn,
  translationsZh,
} from '@spartacus/assets';

export const customTranslations = {
  i18n: {
    resources: {
      resources: { en: translationsEn, de: translationsDe, zh: translationsZh },
    },
    chunks: translationChunksConfig,
    fallbackLang: 'en',
  },
};
export const i18nOverwrites = {
  i18n: {
    resources: {
      // lang
      en: {
        // chunk
        checkout: {
          // keys (nested)
          checkoutReview: {
            paymentMethod: 'Payment Method',
            review: 'Review Order Details',
          },
        },
        quote: {
          quote: {
            summary: {
              actions: {
                SUBMIT: 'Request Quote',
                CANCEL: 'Cancel Request',
              },
            },
          },
        },
      },
      de: {
        cart: {
          orderCost: {
            orderSummary: 'Bestellung',
          },
        },
        quote: {
          quote: {
            summary: {
              actions: {
                SUBMIT: 'Angebot anfragen',
                CANCEL: 'Anfrage stornieren',
              },
            },
            header: {
              overview: {
                purchaseOrderNumber: 'Bestellnummer',
              },
            },
          },
        },
      },
    },
  },
};
